
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';

const AttributeSeparator = ({appConfig, definition, infoDefinition}) => {

    const classNames = mergeStyleSets({
        root: {
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        },
        separatorLine: {
            borderTop: 'solid 1px #dddddd',
            marginTop: 8,
            marginBottom: 8
        },
        separatorSpace: {
            marginTop: 8,
            marginBottom: 8
        }
    });

    const className = definition.space ? classNames.separatorSpace : classNames.separatorLine;

    return (
        <Stack className={classNames.root}>
            <div className={className}></div>
        </Stack>
    );
}

export default AttributeSeparator;
